import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { Location } from "../../domain";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetLocationByIdUsecase implements UseCase<string, Location> {

    constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: string): Observable<Location> {
    return this.locationRepository.getLocationById(params);
  }

}
